import { render, staticRenderFns } from "./FoodPortionDialog.vue?vue&type=template&id=105a126c"
import script from "./FoodPortionDialog.vue?vue&type=script&lang=js"
export * from "./FoodPortionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports